module.exports = __webpack_public_path__ + "static/media/mascot_sharedempty.b3eb5b89.png";